// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._14WVtA8wxsxXxoiq2XYTga {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n._14WVtA8wxsxXxoiq2XYTga h1 {\n  margin: 0.5em;\n}\n\n.VMxljkSEq0EBmpzVg3sFH {\n  margin: 0.5em;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_14WVtA8wxsxXxoiq2XYTga",
	"back": "VMxljkSEq0EBmpzVg3sFH"
};
module.exports = exports;
